module.exports = __webpack_public_path__ + "static/media/xls-file.525cd5f4.svg";